import * as React from "react"
import * as ReactDOM from "react-dom"
import * as Field from "../lib/sbhtml/field"
import {ManagedForm, Heading} from "../lib/sbhtml/form"
import {SingleBox as Select} from "../lib/sbhtml/select"
import {CallJs as CallJsFunction} from "../lib/types"
import {CommandCaller} from "../lib/commands"

export interface Account {
	id: number
	name: string
	configuration: string
}

export interface Props {
	paymentMethodListPage: string
	ajaxPageUrl: string
	currentAccountId: number
	accounts: Account[]
	reusablePayerId: number
}

interface ReusablePayerSetupState {
	currentAccountId: number
}

class ReusablePayerSetup extends React.Component<Props, ReusablePayerSetupState> {
	constructor(props?:Props, context?:any) {
		super(props, context)
		this.state = {
			currentAccountId: props ? props.currentAccountId : 0,
		}
	}

	render() {
		const updateCurrentAccount = (value:string) =>
			this.setState({
				currentAccountId: Number.parseInt(value)
			})

		return <ManagedForm hasSave={true} hasCancel={true}
			onCancel={() => this.cancel()}
			onSubmit={() => {
				// TODO Port to async/await
				if (!this.isValid()) {
					alert("Please select an account")
					return Promise.resolve()
				}
				return this.save()
		    }}
		>
			<ReusablePayerSetupForm
				accounts={this.props.accounts}
				currentAccountId={this.state.currentAccountId}
				updateCurrentAccount={updateCurrentAccount}
			/>
		</ManagedForm>
	}

	private isValid() {
		return this.state.currentAccountId !== 0 &&
			this.props.accounts.map((a) => a.id).indexOf(this.state.currentAccountId) != -1
	}

	private cancel() {
		window.location.assign(this.props.paymentMethodListPage)
	}

	private save() {
		return (new CommandCaller(this.props.ajaxPageUrl)
			.runPost('save reusable payer settings', {
				id:        this.props.reusablePayerId,
				accountId: this.state.currentAccountId
			}) as Promise<void>)
	}
}

interface FormProps {
	currentAccountId: number
	accounts: Account[]
	updateCurrentAccount: (value:string) => void
}

class ReusablePayerSetupForm extends React.Component<FormProps, {}> {
	static type(acc:Account) {
		switch (acc.configuration) {
			case "securepay":
				return "SecurePay"
			case "eway rapid":
				return "eWay Rapid"
			default:
				return acc.configuration
		}
	}

	render () {
		const optionFromAccount = (account: Account) =>
			<option key={account.id} value={"" + account.id}>
				{account.name} ({ReusablePayerSetupForm.type(account)})
			</option>

		const zerothOption = this.props.currentAccountId == 0 ? [<option key="0" value="0"/>] : []
		const otherOptions = this.props.accounts.map(optionFromAccount)
		const options = zerothOption.concat(otherOptions)

		return <div>
			<Heading>Reusable Payer Method Setup</Heading>
			<Field.Group heading="Settings">
				<Field.Item label="Account Settings" isRequired={true}>
					<Select value={"" + this.props.currentAccountId} onChange={this.props.updateCurrentAccount}>
						{options}
					</Select>
				</Field.Item>
			</Field.Group>
		</div>
	}
}

export var reusablePayerSetupCallJs:CallJsFunction<Props> = (callback, props) => {
	const div = document.createElement('div')
	callback(div)
	ReactDOM.render(<ReusablePayerSetup
		ajaxPageUrl={props.ajaxPageUrl}
		currentAccountId={props.currentAccountId}
		accounts={props.accounts}
		reusablePayerId={props.reusablePayerId}
		paymentMethodListPage={props.paymentMethodListPage}
	/>, div)
}



// WEBPACK FOOTER //
// ./src/orders2/reusable-payer-setup.tsx